import store from "../store";

export default {
    beforeRouteEnter(to, from, next) {
        if (store.state.authenticatedUser) {
            next({ name: "home" });
        } else {
            next();
        }
    }
};
